<template>
  <div class="layout-row item">
    <div class="ava-body">
      <img class="ava" v-lazy="item.avatar" @click="user" alt="" />
      <img
        v-if="item.is_official == 1"
        class="v"
        src="../../image/large_official_icon.png"
        alt=""
      />
    </div>

    <div class="layout-col" style="flex: 1">
      <div class="layout-row title f-j-b">
        <div class="layout-col" style="height: 1.75rem" @click="user">
          <div class="name layout-row">
            <!--    :style="item.is_official == 1 ? 'color:#FF7859' : ''" -->
            <div>{{ item.nickname }}</div>
            <img
            class="officialImg"
              v-if="$route.query.is_message == 1 && item.is_official == 1"
              src="../../image/icon_official.png"
              alt=""
            />
          </div>
          <div class="time">{{ item.location }} {{ item.publish_time }}</div>
        </div>
        <img
          v-if="item.digg_count > 200"
          style="height: 1.5rem"
          src="../../image/god_comment_icon.png"
          alt=""
        />
      </div>
      <div v-if="is_slot" class="Reply" ref="Reply">
        <slot />
      </div>
      <Kcontent
        v-if="item.content"
        @tap="replyTap"
        :row="5"
        :text="item.content"
      />
      <div v-if="item.img_url">
        <img
          @click="showImg(item.img_url)"
          style="width: 33%"
          :src="item.img_url"
          alt=""
        />
      </div>

      <primaryTi v-if="showTi == 1" :item="item" />
      <set :data="{ type: 0 }" :item="item" />
    </div>
  </div>
</template>

<script>
import set from "./set";
import primaryTi from "./primaryTi";
import Kcontent from "./content";

export default {
  props: ["showTi", "item"],
  components: {
    set,
    primaryTi,
    Kcontent,
  },
  data() {
    return {
      is_slot: true,
    };
  },
  created() {
    this.item.img_url = img_b(this.item.img_url);
    this.$nextTick(() => {
      this.is_slot = this.$refs.Reply.childNodes.length > 0;
    });
  },
  methods: {
    // is_coll(item) {
    //   if (location.pathname == "/h5/tiku/shoucang") {
    //     let b = false;
    //     for (let e of item.replay) {
    //       if (e.is_coll == 1) {
    //         b = true;
    //       }
    //     }
    //     return b;
    //   }
    //   return true;
    // },
    showImg(src) {
      vant.ImagePreview([src]);
    },
    user() {
      if (this.item.user_id == this.$route.query.user_id) {
        return;
      }
      let routes = [
        {
          path: `/h5/user/${this.item.user_id}`,
          component: (resolve) => require(["../userMy.vue"], resolve),
          name: `/h5/user/${this.item.user_id}`,
        },
      ];
      this.$router.addRoutes(routes);
      this.$router.push({
        path: `/h5/user/${this.item.user_id}`,
        query: {
          user_id: this.item.user_id,
        },
      });
    },
    replyTap() {
      this.$store.commit("setCommentSetShow", {
        show: true,
        update: 0,
        data: this.item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.officialImg{
  height: 0.7rem;
  margin: auto .4rem;
}
.Reply {
  margin-top: 1rem;
  background: #fff9f1;
  // border: 1px solid #f1e6de;
  border-bottom: none;
  box-sizing: border-box;
}
.item {
  padding: 0.75rem;
  border-bottom: 1px solid #f2f4f6;
  .comment-but {
    justify-content: flex-end;
    padding-top: 1rem;
    span {
      margin-left: 0.75rem;
    }
  }
  .ava-body {
    .ava {
      margin-top: 0.25rem;
      height: 1.2rem;
      width: 1.2rem;
      border-radius: 50%;
      margin-right: 0.4rem;
    }
    position: relative;
    .v {
      position: absolute;
      right: 0.3rem;
      top: 1rem;
      width: 0.6rem;
      height: 0.6rem;
      // z-index: 1;
    }
  }

  .title {
    .name {
      font-size: 0.7rem;
      color: #2d549a;
    }
    .time {
      font-size: 0.55rem;
      color: #aaaaaa;
    }
  }
  .text {
    margin-top: 0.55rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #333333;
    line-height: 1.15rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/Item.vue